import { useRequiredContext } from "@redotech/react-util/context";
import { useHandler } from "@redotech/react-util/hook";
import { TeamContext } from "@redotech/redo-web/context/team-context";
import { useQueryClient } from "@tanstack/react-query";
import { getCustomAnalyticsReportFilterOptionsQueryKey } from "./use-custom-analytics-report-filter-options-query";
import { getCustomAnalyticsReportQueryInvalidationKey } from "./use-custom-analytics-report-query";
import { getCustomAnalyticsReportRevisionsQueryInvalidationKey } from "./use-custom-analytics-report-revisions-query";
import { getCustomAnalyticsReportsQueryInvalidationKey } from "./use-custom-analytics-reports-query";

export function useInvalidateCustomAnalyticsReports() {
  const queryClient = useQueryClient();
  const team = useRequiredContext(TeamContext);

  return useHandler(() => {
    void queryClient.invalidateQueries({
      queryKey: getCustomAnalyticsReportsQueryInvalidationKey(team._id),
      exact: false,
    });
    void queryClient.invalidateQueries({
      queryKey: getCustomAnalyticsReportFilterOptionsQueryKey(team._id),
    });
    void queryClient.invalidateQueries({
      queryKey: getCustomAnalyticsReportQueryInvalidationKey(team._id),
      exact: false,
    });
    void queryClient.invalidateQueries({
      queryKey: getCustomAnalyticsReportRevisionsQueryInvalidationKey(team._id),
      exact: false,
    });
  });
}
